module.exports = "/packs/media/images/homecook_3-a4c23975c26de3785c9fca3302249b0d.jpg";